import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
const espera = ['Seguís buscando actividades a último momento.', 'Seguís guardando publicaciones que nunca usás.', 'Seguís armando cada clase desde cero.', 'Seguís posponiendo esa jornada que querías hacer.'];
const hoy = ['Abrís el Mega Pack.', 'Elegís el tema.', 'Encontrás la propuesta.', 'La llevás al aula.'];
export function WhyTodaySection() {
  return <section className="w-full bg-cream px-4 py-11 sm:px-8 sm:py-16" data-id="element-194" data-mp="accyrajk458f">
      <div className="mx-auto max-w-6xl" data-id="element-195" data-mp="5djm1kc3gi9b">
        <div className="grid grid-cols-1 gap-6 sm:gap-10 lg:grid-cols-2 lg:gap-14" data-id="element-196" data-mp="5el5od76ed2n">
          <div data-id="element-197" data-mp="k37l0ewsz4tv">
            <h2 className="font-display text-2xl font-extrabold leading-tight text-ink-900 sm:text-4xl" data-id="element-198" data-mp="k3r4w160k3aj">
              ¿Por qué empezar hoy?
            </h2>
            <p className="mt-2.5 font-sans text-sm text-ink-700 sm:mt-4 sm:text-lg" data-id="element-199" data-mp="3nppt4o6obrgw">
              Porque cada semana que pasa...
            </p>
            <ul className="mt-3 space-y-1 font-sans text-sm text-ink-600 sm:mt-5 sm:space-y-2 sm:text-lg" data-id="element-200" data-mp="3ipk6jmf9gv5o">
              {espera.map(item => <li key={item} data-id="element-201" data-mp="2wbrp5htbp3ih">{item}</li>)}
            </ul>
          </div>

          <div className="rounded-2xl bg-ink-900 p-5 text-cream sm:p-8" data-id="element-202" data-mp="312rosutttzoo">
            <h3 className="font-display text-lg font-extrabold leading-snug sm:text-2xl" data-id="element-203" data-mp="362cwbtn2bgd0">
              Con el Mega Pack, tu preparación son cuatro pasos.
            </h3>
            <ol className="mt-4 space-y-2 sm:mt-6 sm:space-y-3" data-id="element-204" data-mp="29dwtwwyutcih">
              {hoy.map((item, index) => <li key={item} className="flex items-center gap-3 font-sans text-sm text-cream-200 sm:gap-4 sm:text-lg" data-id="element-205" data-mp="2dfrwe4sitvxu" data-mpi={index}>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-gold/50 font-display text-xs font-bold text-gold-400 sm:h-8 sm:w-8 sm:text-sm" data-id="element-206" data-mp="2ndg2trzhorvu">
                    {index + 1}
                  </span>
                  {item}
                </li>)}
            </ol>
          </div>
        </div>

        <div className="mt-8 flex gap-4 rounded-2xl border border-ink-600/20 bg-white p-5 shadow-card sm:mt-12 sm:gap-8 sm:p-8" data-id="element-207" data-mp="3441q53q1b6eq">
          <ShieldCheckIcon className="h-8 w-8 shrink-0 text-gold-600 sm:h-12 sm:w-12" strokeWidth={1.5} aria-hidden="true" data-id="element-208" data-mp="3izr7gok9yvd4" />
          <div data-id="element-209" data-mp="2qbvcppe9ndiz">
            <p className="font-sans text-[11px] font-bold uppercase tracking-[0.16em] text-gold-600 sm:text-xs sm:tracking-[0.18em]" data-id="element-210" data-mp="2qdg8ficbh2if">
              Garantía de 7 días
            </p>
            <h3 className="mt-1 font-display text-lg font-extrabold text-ink-900 sm:mt-2 sm:text-2xl" data-id="element-211" data-mp="302q232mt6t8n">
              Probalo durante 7 días
            </h3>
            <p className="mt-2 max-w-2xl font-sans text-sm leading-relaxed text-ink-700 sm:mt-3 sm:text-base" data-id="element-212" data-mp="2v9epslz89k9c">
              Comprás el Mega Pack, recibís el acceso y revisás todo el
              material. Si considerás que no es para vos, podés solicitar el
              reembolso dentro de los primeros 7 días, de acuerdo con las
              condiciones de compra.
            </p>
          </div>
        </div>
      </div>
    </section>;
}